export default "__VITE_ASSET__DqeGp3W$__"